/**
 * Subscribe Form Fields.
 * @format
 */
import {
  countryList,
  countryParentItemsList,
} from '../../form-components/lists/country-list';
import { stateList } from '../../form-components/lists/state-list';
import { functionalRoles } from '../../form-components/lists/functional-roles';
import { specialtyList } from '../../form-components/lists/specialty-list';

export const marketoProductFields = [
  {
    fieldTitle: 'Salutation',
    fieldName: 'Salutation',
    id: 'Salutation',
    type: 'select',
    placeholderText: 'Salutation',
    errorMessage: 'Salutation field required.',
    required: false,
    list: [
      { name: 'Mr.', value: 'Mr.' },
      { name: 'Mrs.', value: 'Mrs,' },
      { name: 'Ms.', value: 'Ms,' },
      { name: 'Dr.', value: 'Dr,' },
      { name: 'Prof.', value: 'Prof,' },
      { name: 'Prefer not to say', value: 'Prefer not to say' },
    ],
    useNameAsLookupValue: true,
    parentItems: [{ value: 'Physician' }],
    dependencyId: 'specialty-select',
  },
  {
    fieldTitle: 'First name',
    fieldName: 'FirstName',
    id: 'fname',
    type: 'text',
    placeholderText: 'Your first name here',
    errorMessage: 'First Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Last name',
    fieldName: 'LastName',
    id: 'lname',
    type: 'text',
    placeholderText: 'Your last name here',
    errorMessage: 'Last Name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Email address',
    fieldName: 'Email',
    id: 'email',
    type: 'email',
    placeholderText: 'name@website.com',
    errorMessage: 'Invalid email.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Company Name',
    fieldName: 'Company',
    id: 'organization',
    type: 'text',
    placeholderText: "Your company's name",
    errorMessage: 'Company name field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Country',
    fieldName: 'Country',
    id: 'country-select',
    type: 'select',
    placeholderText: 'Select a country',
    errorMessage: 'Country field required.',
    required: true,
    list: countryList,
    useNameAsLookupValue: true,
    parentItems: countryParentItemsList,
    dependencyId: 'state-select',
  },
  {
    fieldTitle: 'State or province',
    fieldName: 'State',
    id: 'state-select',
    type: 'select',
    placeholderText: 'Select a state or province',
    errorMessage: 'State or province field required.',
    required: true,
    list: stateList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'City',
    fieldName: 'City',
    id: 'city',
    type: 'text',
    placeholderText: '',
    errorMessage: 'City field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Postal Code',
    fieldName: 'PostalCode',
    id: 'postal-code',
    type: 'text',
    placeholderText: '',
    errorMessage: 'Postal code field required.',
    required: true,
    list: null,
    useNameAsLookupValue: false,
    dependentField: true,
  },
  {
    fieldTitle: 'Functional role',
    fieldName: 'Functional_role__c',
    id: 'functional-role-select',
    type: 'select',
    placeholderText: 'Select a role',
    errorMessage: 'Functional role field required.',
    required: true,
    list: functionalRoles,
    useNameAsLookupValue: true,
    parentItems: [
      { value: 'Chief/Dept Administrator' },
      { value: 'IT - Management' },
      { value: 'IT - Technician' },
      { value: 'Nurse' },
      { value: 'Nurse - Manager' },
      { value: 'Physician' },
      { value: 'Therapist/Technician/Technologist/Operator' },
      { value: 'Therapist - Chief' },
      { value: 'Veterinary Staff' },
    ],
    dependencyId: 'specialty-select',
  },
  {
    fieldTitle: 'Specialty',
    fieldName: 'Specialty__c',
    id: 'specialty-select',
    type: 'select',
    placeholderText: 'Select a specialty',
    errorMessage: 'Specialty field required.',
    required: true,
    list: specialtyList,
    useNameAsLookupValue: true,
    dependentField: true,
  },
  {
    fieldTitle: 'Phone number',
    fieldName: 'Phone',
    id: 'phone',
    type: 'tel',
    placeholderText: '(000) 000 0000',
    errorMessage: 'Phone number field required.',
    required: false,
    list: null,
    useNameAsLookupValue: false,
  },
  {
    fieldTitle: 'Comment',
    fieldName: 'mktoCommentCapture',
    id: 'comment',
    type: 'textarea',
    placeholderText: '',
    errorMessage: '',
    required: true,
    list: null,
    useNameAsLookupValue: false,
  },
];
